import { useMemo } from 'react';

/**
 * Custom hook to get column configuration for a crop type
 */

// Standard columns for vegetable, herb, and cover crop types
const STANDARD_COLUMNS = [
  { key: 'name', header: 'Name' },
  { key: 'soil_effect', header: 'Soil Effect' },
  { key: 'pre_germination', header: 'Pre-Germination' },
  { key: 'direct_sowing', header: 'Direct Sowing' },
  { key: 'setting', header: 'Setting' },
  { key: 'planting', header: 'Planting' },
  { key: 'growth_time', header: 'Growth Time' },
  { key: 'grid', header: '12-Month Grid' }
];

// Period type labels for dynamic fruit columns
const PERIOD_TYPE_LABELS = {
  'pre_germination': 'Pre-Germination',
  'direct_sowing': 'Direct Sowing',
  'setting': 'Setting',
  'planting': 'Planting',
  'pruning': 'Pruning',
  'harvest': 'Harvest',
  'picking': 'Picking'
};

const getFruitColumns = (cropTypeData) => {
  const columns = [{ key: 'name', header: 'Name' }];
  
  if (cropTypeData?.allowed_period_types) {
    cropTypeData.allowed_period_types.forEach(periodType => {
      if (PERIOD_TYPE_LABELS[periodType]) {
        columns.push({
          key: periodType,
          header: PERIOD_TYPE_LABELS[periodType]
        });
      }
    });
  }
  
  columns.push({ key: 'grid', header: '12-Month Grid' });
  return columns;
};

export const useCropColumns = (crops, selectedCropType) => {
  const columns = useMemo(() => {
    // Handle dynamic columns for fruits
    if (selectedCropType === 'fruit') {
      const cropTypeData = crops.find(crop =>
        crop.crop_type?.name?.toLowerCase() === 'fruit'
      )?.crop_type;

      const dynamicColumns = getFruitColumns(cropTypeData);
      return {
        headers: dynamicColumns.map(col => col.header),
        columns: dynamicColumns.map(col => col.key)
      };
    }

    // Handle standard columns for vegetable, herb, cover_crop
    if (['vegetable', 'herb', 'cover_crop'].includes(selectedCropType)) {
      return {
        headers: STANDARD_COLUMNS.map(col => col.header),
        columns: STANDARD_COLUMNS.map(col => col.key)
      };
    }

    return { headers: [], columns: [] };
  }, [crops, selectedCropType]);

  return columns;
};



